/**
 * Cleans query parameters by removing undefined, null, empty strings, and the string "undefined" values
 */
export function cleanQueryParams(query: Record<string, any>): Record<string, any> {
  const cleaned: Record<string, any> = {}
  for (const [key, value] of Object.entries(query)) {
    // Skip undefined, null, empty strings, and the string "undefined"
    if (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== 'undefined' &&
      // Skip empty arrays
      !(Array.isArray(value) && value.length === 0)
    ) {
      cleaned[key] = value
    }
  }
  return cleaned
}
